/*
 * AUTO-GENERATED, DO NOT EDIT
 */
import React from 'react';
function CheckmarkCircleIcon(props, svgRef) {
    return (React.createElement("svg", Object.assign({ "data-sanity-icon": "checkmark-circle", width: "1em", height: "1em", viewBox: "0 0 25 25", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: svgRef }, props),
        React.createElement("circle", { cx: 12.5, cy: 12.5, r: 8, stroke: "currentColor", strokeWidth: 1.2 }),
        React.createElement("path", { d: "M9.5 12.1316L11.7414 14.5L16 10", stroke: "currentColor", strokeWidth: 1.2 })));
}
const ForwardRef = React.forwardRef(CheckmarkCircleIcon);
export default ForwardRef;
//# sourceMappingURL=checkmarkCircleIcon.js.map